import { Box, Text } from "@chakra-ui/react"

function TopHeader() {
    return (
        <Box bg="brand.500" position="sticky" top="0" zIndex={9}>
            <Text align="center" p={2} variant="paragraph" color="white">Let's Get Started!</Text>
        </Box>
    )
}

export default TopHeader